// Loose stone Size / Sub Size / Color / Clarity are free text boxes with a
// saved list. A value typed on a purchase that isn't in its list yet is
// added to it once the invoice saves, so it's offered next time.

import { arrayUnion, doc, setDoc, type Firestore } from 'firebase/firestore';

export type LooseOptionField = 'looseSizeOptions' | 'looseSubSizeOptions' | 'looseColorOptions' | 'looseClarityOptions';

/**
 * `lists` = what the form offered for each field (for Color / Clarity that
 * may be the default grades when nothing is saved yet: those are written
 * along with the new value so the defaults aren't lost). `stored` = what's
 * saved in settings now. `values` = everything typed on the invoice.
 */
export async function rememberLooseOptions(
  db: Firestore, businessId: string,
  fields: { field: LooseOptionField; offered: string[]; stored: string[] | undefined; values: string[] }[],
) {
  const patch: Record<string, unknown> = {};
  for (const f of fields) {
    const known = new Set(f.offered.map(v => v.toLowerCase()));
    const fresh = [...new Set(f.values.map(v => v.trim()).filter(Boolean))]
      .filter(v => !known.has(v.toLowerCase()));
    if (fresh.length === 0) continue;
    const seed = (f.stored?.length ?? 0) === 0 ? f.offered : [];
    patch[f.field] = arrayUnion(...seed, ...fresh);
  }
  if (Object.keys(patch).length === 0) return;
  await setDoc(doc(db, 'settings', businessId), patch, { merge: true });
}
